<template>
  <div class="dblb-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.orderType" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="车间">
              <el-select v-model="searchForm.factory" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :key="item.factory_id" :label="item.simple_name"  :value="item.factory_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="打包状态">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option label="缺件" :value="0" />
                <el-option label="完整" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" style="width:200px" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" type="primary" @click="printPackqd">打包清单</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="150"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.ordernum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="100"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.produnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.delname && scope.row.delname.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.delname }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.orderType===0">正单</span>
                      <span v-if="scope.row.orderType===1">客改单</span>
                      <span v-if="scope.row.orderType===2">增补单</span>
                      <span v-if="scope.row.orderType===3">色板单</span>
                      <span v-if="scope.row.orderType===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="部件数量"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;">{{scope.row.comnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="包装状态"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag size="mini" :disable-transitions="true" v-if="scope.row.packtime!==null&&scope.row.packtime!==''&&scope.row.packtime!==undefined">包装完整</el-tag>
                      <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.packtime===null||scope.row.packtime===''||scope.row.packtime===undefined">缺件 {{scope.row.comnum-scope.row.packednum}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="包装数量"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;">{{scope.row.packnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="入库数量"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#67C23A;font-weight: 500;">{{scope.row.inpacknum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="未入库数量"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#F56C6C;font-weight: 500;">{{scope.row.packnum-scope.row.inpacknum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="分派工厂"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.factoryname}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="排产时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
<!--                  <el-table-column-->
<!--                    label="最近打包时间"-->
<!--                    width="170"-->
<!--                    show-overflow-tooltip>-->
<!--                    <template slot-scope="scope">-->
<!--                      <span v-if="scope.row.packnum>0"><i class="el-icon-time"></i> {{scope.row.time}}</span>-->
<!--                      <span v-if="scope.row.packnum===0" style="color:#99a9bf">未打包</span>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column
                    label="操作"
                    width="250"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button size="mini" @click="openPackDetails(scope.row)" icon="el-icon-tickets">包装详细</el-button>
                      <el-button size="mini" @click="openDetails(scope.row)" icon="el-icon-link">部件详细</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="packTitle"
      :visible.sync="editVisible"
      width="60%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form size="small" ref="editForm" :inline="true" :model="editForm" :rules="editRules" label-width="60px">
        <el-form-item label="标签号" prop="packnum">
          <el-input v-model="editForm.packnum" maxlength="14" style="width: 130px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="包号" prop="xuhao">
          <el-input type="number" v-model="editForm.xuhao" style="width: 80px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="imark">
          <el-select v-model="editForm.imark" style="width: 100px" clearable>
            <el-option label="未入库" value="0"></el-option>
            <el-option label="已入库" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchPack" icon="el-icon-search">搜索</el-button>
          <el-button type="danger" @click="batchUnpack" icon="el-icon-remove-outline" plain>批量拆包</el-button>
          <el-button type="primary" @click="completePack" :loading="btnLoading">打包完成</el-button>
        </el-form-item>
      </el-form>
      <div style="height: 400px;width: 100%" v-loading="packloading">
        <pl-table
          :key="tableKey"
          height="400px"
          :datas="packTableData"
          :data="packTableData"
          use-virtual
          :pagination-show="false"
          @selection-change="handleSelectionChange"
          size="small"
          :row-height="45">
          <pl-table-column type="selection" :selectable='checkboxT' align="center" width="50"></pl-table-column>
          <pl-table-column prop="packnum" :resizable="false" align="center" label="包标签号" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="xuhao" :resizable="false" align="center" label="包号" show-overflow-tooltip width="90"></pl-table-column>
          <pl-table-column prop="username" :resizable="false" align="center" label="打包人" show-overflow-tooltip width="100"></pl-table-column>
          <pl-table-column prop="time" :resizable="false" align="center" label="打包时间" show-overflow-tooltip min-width="130"></pl-table-column>
          <pl-table-column prop="num" :resizable="false" align="center" label="部件数量" show-overflow-tooltip width="90"></pl-table-column>
          <pl-table-column label="状态" :resizable="false" width="90" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :disable-transitions="true" v-if="scope.row.imark===1">已入库</el-tag>
              <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.imark===0">未入库</el-tag>
            </template>
          </pl-table-column>
          <pl-table-column label="操作" :resizable="false" width="100" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.imark===0" size="mini" icon="el-icon-remove-outline" @click="unpack(scope.row)">拆包</el-button>
              <el-button v-if="scope.row.imark!==0" size="mini" icon="el-icon-remove-outline" :disabled="true">拆包</el-button>
            </template>
          </pl-table-column>
        </pl-table>
      </div>
    </el-dialog>
    <el-dialog
      :title="packInfoTitle"
      :visible.sync="editInfoVisible"
      width="80%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form size="small" ref="editInfoForm" :inline="true" :model="editInfoForm" label-width="70px">
        <el-form-item label="区域" prop="area">
          <el-select v-model="editInfoForm.area" style="width: 200px" filterable clearable>
            <el-option v-for="item in areaList" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类" prop="type">
          <el-select v-model="editInfoForm.type" style="width: 100px" filterable clearable>
            <el-option v-for="item in typeList" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包装状态" prop="mmark">
          <el-select v-model="editInfoForm.mmark" style="width: 100px" clearable>
            <el-option label="未包" value="0"></el-option>
            <el-option label="已包" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包装" prop="packid">
          <el-select v-model="editInfoForm.packid" style="width: 240px" filterable clearable>
            <el-option
              v-for="item in packList"
              :label="item.packxuhao+' / '+item.packnum"
              :value="item.packid">
              <span style="float: left">{{ '包号：'+item.packxuhao }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.packnum }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入库状态" prop="imark">
          <el-select v-model="editInfoForm.imark" style="width: 100px" clearable>
            <el-option label="未入库" value="0"></el-option>
            <el-option label="已入库" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字" prop="content">
          <el-input v-model="editInfoForm.content" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchPackInfo" icon="el-icon-search">搜索</el-button>
          <el-button type="danger" @click="batchUnpackInfo" icon="el-icon-remove-outline" plain>批量拆除</el-button>
          <el-button icon="el-icon-printer" @click="printBzqw">包装清尾打印</el-button>
          <el-button icon="el-icon-printer" @click="exportInfoExcel">部件导出</el-button>
        </el-form-item>
      </el-form>
      <div style="height: 400px;width: 100%" v-loading="packInfoloading">
        <pl-table
          :key="tableInfoKey"
          height="400px"
          :datas="packInfoTableData"
          :data="packInfoTableData"
          use-virtual
          :pagination-show="false"
          @selection-change="handleSelectionInfoChange"
          size="small"
          :row-height="45">
          <pl-table-column type="selection" :selectable='checkboxInfoT' fixed align="center" width="50"></pl-table-column>
          <pl-table-column prop="bar" :resizable="false" align="center" fixed label="条码" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="xuhao" :resizable="false" align="center" fixed label="序号" show-overflow-tooltip width="80"></pl-table-column>
          <pl-table-column prop="area" :resizable="false" align="center" label="区域" show-overflow-tooltip width="100"></pl-table-column>
          <pl-table-column prop="type" :resizable="false" align="center" label="分类" show-overflow-tooltip width="80"></pl-table-column>
          <pl-table-column prop="name" :resizable="false" align="center" label="名称" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="material" :resizable="false" align="center" label="基材" show-overflow-tooltip width="80"></pl-table-column>
          <pl-table-column :resizable="false" align="center" label="规格" show-overflow-tooltip width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>
              <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>
              <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>
              <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>
              <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>
            </template>
          </pl-table-column>
          <pl-table-column prop="color" :resizable="false" align="center" label="颜色" show-overflow-tooltip min-width="130"></pl-table-column>
          <pl-table-column prop="packnum" :resizable="false" align="center" label="包标签号" show-overflow-tooltip width="130"></pl-table-column>
          <pl-table-column prop="packxuhao" :resizable="false" align="center" label="包号" show-overflow-tooltip width="90"></pl-table-column>
          <pl-table-column label="包装状态" fixed="right" :resizable="false" width="90" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :disable-transitions="true" v-if="scope.row.mmark===1">已包</el-tag>
              <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.mmark===0">未包</el-tag>
            </template>
          </pl-table-column>
          <pl-table-column label="入库状态" fixed="right" :resizable="false" width="90" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :disable-transitions="true" v-if="scope.row.imark===1">已入库</el-tag>
              <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.imark===0">未入库</el-tag>
            </template>
          </pl-table-column>
          <pl-table-column label="操作" :resizable="false" fixed="right" width="100" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.imark===0&&scope.row.mmark===1" size="mini" icon="el-icon-remove-outline" @click="unpackInfo(scope.row)">拆除</el-button>
              <el-button v-if="scope.row.imark!==0||scope.row.mmark===0" size="mini" icon="el-icon-remove-outline" :disabled="true">拆除</el-button>
            </template>
          </pl-table-column>
        </pl-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getErpPackList,
  getErpOrderPackList,
  ErpOrderUnpack,
  getErpOrderPackInfoList,
  ErpOrderUnpackInfo,
  PrintOrderByPackInfoDetailAll,
  getFactoryList,
  completePack,
  printPackList,
  exportPackingTableList,
  exportErpOrderPackInfoList,
  getGroupInfoByUser
} from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'dblb',
  computed: {
    user: getUser
  },
  data() {
    return {
      exportLoading: false,
      fullscreenLoading: false,
      packTitle: '',
      packInfoTitle: '',
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editInfoVisible: false,
      packtypeList: [],
      editForm: {
        packnum: '',
        xuhao: '',
        orderid: '',
        produnum: '',
        imark: ''
      },
      editInfoForm: {
        orderid: '',
        area: '',
        type: '',
        content: '',
        packid: '',
        mmark: '',
        imark: ''
      },
      editRules: {
        ptid: [{ required: true, message: '请选择包装类型', trigger: 'change' }],
        produnum: [{ required: true, message: '请选择订单', trigger: 'change' }]
      },
      tableKey: '',
      multipleSelection: [],
      packTableData: [],
      packloading: false,
      tableInfoKey: '',
      multipleInfoSelection: [],
      packInfoTableData: [],
      packInfoloading: false,
      isfirst: false,
      areaList: [],
      typeList: [],
      packList: [],
      searchForm: {
        type: '',
        search: '',
        factory: '',
        time: '',
        orderType: null
      },
      factoryList: [],
      btnLoading: false,
      group: {
        dBrand: 1
      }
    }
  },
  created() {
    this.getData()
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    this.getFactoryList()
  },
  methods: {
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        const data = {
          content: this.searchForm.search,
          groupid: this.user.dGroupid,
          userid: this.user.dUserid,
          role: this.user.role,
          type: this.searchForm.type,
          factory: this.searchForm.factory,
          startTime: startTime,
          endTime: endTime,
          orderType: this.searchForm.orderType,
          tableName: '打包列表'
        }
        exportPackingTableList(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    exportInfoExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        const data = {
          orderid: this.editInfoForm.orderid,
          area: this.editInfoForm.area,
          type: this.editInfoForm.type,
          content: this.editInfoForm.content,
          packid: this.editInfoForm.packid,
          mmark: this.editInfoForm.mmark,
          imark: this.editInfoForm.imark
        }
        exportErpOrderPackInfoList(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    getFactoryList() {
      getFactoryList().then(response => {
        this.factoryList = response.data
      })
    },
    Search() {
      this.currentPage = 1
      this.getData()
      this.searchForm.search = this.searchForm.search.trim()
    },
    getData() {
      this.loading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        type: this.searchForm.type,
        factory: this.searchForm.factory,
        startTime: startTime,
        endTime: endTime,
        orderType: this.searchForm.orderType
      }
      getErpPackList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSelectionInfoChange(val) {
      this.multipleInfoSelection = val
    },
    openPackDetails(row) {
      this.editForm.orderid = row.orderid
      this.editForm.produnum = row.produnum
      this.editForm.packnum = ''
      this.editForm.xuhao = ''
      this.editForm.imark = ''
      if (row.bid === 3) {
        this.packTitle = row.ordernum + ' 包装列表'
      } else {
        this.packTitle = row.produnum + ' 包装列表'
      }
      this.editVisible = true
      this.searchPack()
    },
    openDetails(row) {
      if (row.bid === 3) {
        this.packInfoTitle = row.ordernum + ' 部件列表'
      } else {
        this.packInfoTitle = row.produnum + ' 部件列表'
      }
      this.editInfoForm.orderid = row.orderid
      this.editInfoForm.area = ''
      this.editInfoForm.type = ''
      this.editInfoForm.content = ''
      this.editInfoForm.packid = ''
      this.editInfoForm.mmark = ''
      this.editInfoForm.imark = ''
      this.isfirst = true
      this.areaList = []
      this.typeList = []
      this.packList = []
      this.editInfoVisible = true
      this.searchPackInfo()
    },
    searchPackInfo() {
      this.packInfoTableData = []
      this.multipleInfoSelection = []
      this.packInfoloading = true
      const data = {
        orderid: this.editInfoForm.orderid,
        area: this.editInfoForm.area,
        type: this.editInfoForm.type,
        content: this.editInfoForm.content,
        packid: this.editInfoForm.packid,
        mmark: this.editInfoForm.mmark,
        imark: this.editInfoForm.imark
      }
      getErpOrderPackInfoList(data).then(response => {
        this.tableInfoKey = new Date().getTime()
        this.packInfoTableData = response.data
        if (this.isfirst) {
          let areaList = []
          let typeList = []
          let packList = []
          for (let p of response.data) {
            let ishavearea = false
            for (let area of areaList) {
              if (area === p.area) {
                ishavearea = true
                break
              }
            }
            if (!ishavearea) {
              areaList.push(p.area)
            }
            let ishavetype = false
            for (let type of typeList) {
              if (type === p.type) {
                ishavetype = true
                break
              }
            }
            if (!ishavetype) {
              typeList.push(p.type)
            }
            if (p.packid !== null && p.packid !== '' && p.packid !== undefined) {
              let ishavepack = false
              for (let pack of packList) {
                if (pack.packid === p.packid) {
                  ishavepack = true
                  break
                }
              }
              if (!ishavepack) {
                packList.push({ packid: p.packid, packnum: p.packnum, packxuhao: p.packxuhao})
              }
            }
          }
          this.areaList = areaList
          this.typeList = typeList
          this.packList = packList
          this.isfirst = false
        }
        this.packInfoloading = false
      }).catch(() => {
        this.packInfoloading = false
      })
    },
    searchPack() {
      this.packTableData = []
      this.multipleSelection = []
      this.packloading = true
      const data = {
        orderid: this.editForm.orderid,
        packnum: this.editForm.packnum,
        xuhao: this.editForm.xuhao,
        imark: this.editForm.imark
      }
      getErpOrderPackList(data).then(response => {
        this.tableKey = new Date().getTime()
        this.packTableData = response.data
        this.packloading = false
      }).catch(() => {
        this.packloading = false
      })
    },
    checkboxInfoT(row, rowIndex) {
      // 控制能否选择
      /* if (row.imark === 1 || row.mmark === 0) {
        return false
      } else {
        return true
      } */
      return true // 默认全可选
    },
    checkboxT(row, rowIndex) {
      if (row.imark === 1) {
        return false
      } else {
        return true
      }
    },
    unpack(row) {
      if (row.packid !== null && row.packid !== '' && row.packid !== undefined) {
        this.subUnpack(row.packid)
      } else {
        this.$message.error('包标签号获取失败')
      }
    },
    unpackInfo(row) {
      if (row.obid !== null && row.obid !== '' && row.obid !== undefined) {
        this.subUnpackInfo(row.obid + '')
      } else {
        this.$message.error('部件ID获取失败')
      }
    },
    batchUnpack() {
      if (this.multipleSelection.length > 0) {
        let ids = []
        for (let m of this.multipleSelection) {
          if (m.packid !== null && m.packid !== '' && m.packid !== undefined) {
            ids.push(m.packid)
          }
        }
        if (ids.length > 0) {
          this.subUnpack(ids.join(','))
        } else {
          this.$message.error('未选中要拆除的包装')
        }
      } else {
        this.$message.error('未选中要拆除的包装')
      }
    },
    batchUnpackInfo() {
      if (this.multipleInfoSelection.length > 0) {
        let ids = []
        for (let m of this.multipleInfoSelection) {
          if (m.obid !== null && m.obid !== '' && m.obid !== undefined) {
            ids.push(m.packid)
          }
        }
        if (ids.length > 0) {
          this.subUnpackInfo(ids.join(','))
        } else {
          this.$message.error('未选中要拆除的部件')
        }
      } else {
        this.$message.error('未选中要拆除的部件')
      }
    },
    subUnpack(ids) {
      const arr = ids.split(',')
      this.$confirm('此操作将拆除此 ' + arr.length + ' 个包装, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        const data = {
          orderid: this.editForm.orderid,
          ids: ids,
          userid: this.user.dUserid
        }
        ErpOrderUnpack(data).then(response => {
          this.fullscreenLoading = false
          this.$message({
            message: '包装拆除成功',
            type: 'success'
          })
          this.searchPack()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },
    subUnpackInfo(ids) {
      const arr = ids.split(',')
      this.$confirm('此操作将此 ' + arr.length + ' 个部件从包装里拆除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        const data = {
          orderid: this.editInfoForm.orderid,
          ids: ids,
          userid: this.user.dUserid
        }
        ErpOrderUnpackInfo(data).then(response => {
          this.fullscreenLoading = false
          this.$message({
            message: '部件拆除成功',
            type: 'success'
          })
          this.searchPackInfo()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },
    printBzqw() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        const data = {
          orderid: this.editInfoForm.orderid,
          area: this.editInfoForm.area,
          type: this.editInfoForm.type,
          content: this.editInfoForm.content,
          packid: this.editInfoForm.packid,
          mmark: this.editInfoForm.mmark,
          imark: this.editInfoForm.imark
        }
        this.fullscreenLoading = true
        PrintOrderByPackInfoDetailAll(data).then(response => {
          LODOP.PRINT_INIT('包装清尾打印')
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
          LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
          LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', response.data)
          LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
          LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
          LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
          LODOP.NewPageA()
          LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
          LODOP.PREVIEW()
          this.fullscreenLoading = false
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }
    },
    completePack() {
      this.$confirm(`您确定此订单打包完成吗？`, '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        this.btnLoading = true
        completePack({ orderid: this.editForm.orderid }).then(response => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.btnLoading = false
          this.editVisible = false
          this.getData()
        })
      }).catch(() => {
        this.btnLoading = false
      })
    },
    printPackqd() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        const printLoading = this.$loading({
          lock: true,
          text: '打包清单正在打印，请勿关闭此页面',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        const data = {
          content: this.searchForm.search,
          groupid: this.user.dGroupid,
          userid: this.user.dUserid,
          role: this.user.role,
          type: this.searchForm.type,
          factory: this.searchForm.factory,
          startTime: startTime,
          endTime: endTime
        }
        printPackList(data).then(response => {
          LODOP.PRINT_INIT('打包清单打印')
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
          LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
          LODOP.ADD_PRINT_TABLE(30, 1, '100%', '100%', response.data)
          LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
          LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
          LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
          LODOP.NewPageA()
          LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
          LODOP.PREVIEW()
          printLoading.close()
        }).catch(() => {
          printLoading.close()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dblb-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
